



// ===================new code 

import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpResponse,
  HttpParams,
} from "@angular/common/http";
import { Observable, from, of, throwError, BehaviorSubject } from "rxjs";
import { switchMap, catchError, map, filter, take,tap } from "rxjs/operators";
import { EncryptService } from "../data-service/EncryptDecryptService/encrypt-service";
import { IndexdbService } from "../data-service/EncryptDecryptService/indexdb-service";
import { CookieService } from "ngx-cookie-service";
import { environment } from "@env";
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { HttpHeaders } from '@angular/common/http';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Inject, PLATFORM_ID,Optional } from '@angular/core';

@Injectable()
export class EncryptInterceptor implements HttpInterceptor {

  private keyReady$ = new BehaviorSubject<boolean>(false);
  private keyInitInProgress = false;
  keyRefreshCounter: number = 0;

  constructor(
    private encryptService: EncryptService,
    private indexdbService: IndexdbService,
    private cookieService: CookieService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(REQUEST) private ssrRequest: any
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    /* ======================= URL EXCLUSIONS ======================= */
    const isKeyApi = request.url.includes("Key");
    const isSocket =
      request.url.includes("socket.pcrown.net") ||
      request.url.includes("socket.practicecrown.com");
    const isHQ = request.url.includes("hq");
    const isFileDownload = request.url.includes("File/download");
    const isMultipart = request.body instanceof FormData;

    /* ======================= HARD SKIPS ======================= */
    if (isSocket || isHQ) {
      return next.handle(request);
    }

    /* ======================= KEY API NO ENCRYPT ======================= */
    if (isKeyApi) {
      const cleanReq = request.clone({
        headers: request.headers
          .set("accept", "application/json, text/plain")
      });
      return next.handle(cleanReq);
    }
    //let headers = request.headers;
   

    

    

    if (this.ssrRequest) {
      let headers = request.headers;
  
      const cookieHeader = this.ssrRequest.headers?.cookie;
      console.log("SSR Request detected. Cookie header:", cookieHeader);
  
      if (cookieHeader) {
  
        headers = headers.set('Cookie', cookieHeader);
  
        request = request.clone({
          headers
        });
  
      }
    }

    /* ======================= ENSURE KEY ======================= */
    return this.ensureCryptoKey().pipe(
      switchMap(() => this.processRequest(request, next, {
        isFileDownload,
        isMultipart
      })),
      catchError(err => this.safeError(err))
    );
  }

  /* ========================================================= */
  
  /* ======================= CORE FLOW ======================= */
  /* ========================================================= */

  private processRequest(
    request: HttpRequest<any>,
    next: HttpHandler,
    flags: { isFileDownload: boolean; isMultipart: boolean }
  ): Observable<HttpEvent<any>> {

    return this.encryptQueryParamsIfNeeded(request).pipe(
      switchMap(reqWithParams => {

        /* ===== FILE DOWNLOAD ===== */
        if (flags.isFileDownload) {
          const binaryReq = reqWithParams.clone({
            responseType: "arraybuffer" as "json"
          });

          return next.handle(binaryReq).pipe(
            map(event => {
              if (event instanceof HttpResponse) return event;
              return event;
            })
          );

        }

        /* ===== MULTIPART ===== */
        if (flags.isMultipart) {
          return next.handle(reqWithParams).pipe(
            switchMap(event => this.decryptIfNeeded(event))
          );
        }

        /* ===== NORMAL BODY ===== */
        if (reqWithParams.body) {
          console.log(reqWithParams.url,"ORIGINAL PAYLOAD →", JSON.stringify(reqWithParams.body));
          
          return from(this.encryptService.DataEncryption(reqWithParams.body)).pipe(
           
            switchMap(encBody => {
              console.log(encBody,"ENCRYPTED PAYLOAD →");
              const encryptedReq = reqWithParams.clone({ body: encBody });
              return next.handle(encryptedReq).pipe(
                switchMap(event => this.decryptIfNeeded(event)),
                catchError(err => this.handle401(err, request, next))
              );
            })
            
          );
        }

        /* ===== NO BODY ===== */
        return next.handle(reqWithParams).pipe(
          switchMap(event => this.decryptIfNeeded(event))
        );
      })
    );
  }

  /* ========================================================= */
  /* ======================= KEY FLOW ======================== */
  /* ========================================================= */

  private ensureCryptoKey(): Observable<boolean> {

    if (this.keyReady$.value === true) {
      return of(true);
    }

    if (this.keyInitInProgress) {
      return this.keyReady$.pipe(
        filter(v => v === true),
        take(1)
      );
    }

    this.keyInitInProgress = true;

    return this.indexdbService.getCryptoKey().pipe(
      map(() => {
        this.keyInitInProgress = false;
        this.keyReady$.next(true);
        return true;
      }),
      catchError(err => {
        this.keyInitInProgress = false;
        this.keyReady$.next(false);  // 🔥 isolate error
        return of(false);            // 🔥 never error stream
      })
    );
  }

  /* ========================================================= */
  /* =================== PARAM ENCRYPTION ==================== */
  /* ========================================================= */

  private encryptQueryParamsIfNeeded(req: HttpRequest<any>): Observable<HttpRequest<any>> {
    if (!req.params.keys().length) return of(req);

    const rawQuery = req.urlWithParams.split("?")[1] || "";
    console.log(rawQuery,"quesry params to encrypt");
    return from(this.encryptService.DataEncryption(rawQuery)).pipe(
      map((encrypted: any) => {
        console.log('encrypted query params',encrypted)
        const encoded = encodeURIComponent(encrypted.data ?? encrypted);
        console.log('encoded query params',encoded)
        return req.clone({
          params: new HttpParams().set("q", encoded),
        });
      })
    );
  }

  /* ========================================================= */
  /* ================== RESPONSE DECRYPTION ================== */
  /* ========================================================= */

  private decryptIfNeeded(event: HttpEvent<any>): Observable<HttpEvent<any>> {
    console.log(event, "response received - ");
    if (!(event instanceof HttpResponse)) return of(event);

    return from(
      this.encryptService.dataDecryptionObservable(event.body ?? {})
    ).pipe(
      map((dec) => {
        console.log(event.url+   " response body - ", dec)
        return event.clone({ body: dec })
      }),
      catchError(err => of(event)) // 🔥 never poison stream
    );
  }

  /* ========================================================= */
  /* =================== ERROR HANDLING ====================== */
  /* ========================================================= */

  private handle401(
    err: any,
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (err instanceof HttpErrorResponse && err.status === 401 && this.keyRefreshCounter < environment.keyrefreshlimit) {
      this.cookieService.delete("ckey");
      this.keyReady$.next(false);
      this.keyInitInProgress = false;
      this.keyRefreshCounter++;

      return this.ensureCryptoKey().pipe(
        switchMap(() => this.processRequest(request, next, {
          isFileDownload: request.url.includes("File/download"),
          isMultipart: request.body instanceof FormData
        }))
      );
    }

    return throwError(() => err);
  }


 

  private safeError(err: any) {
    if (err instanceof HttpErrorResponse && err.error) {
      return from(this.encryptService.dataDecryptionObservable(err.error)).pipe(
        map(decErr => {
          const newErr = new HttpErrorResponse({
            ...err,
            error: decErr
          });
          throw newErr;
        }),
        catchError(() => throwError(() => err))
      );
    }
    return throwError(() => err);
  }
}




